export default {
  LANDSCAPE : 'landscape',
  SQUARE    : 'square',
  VERTICAL  : 'vertical'
};
